import { LinkTab, LoadingIndicator, Tabs } from '@ygtechnologies/bygr-frontend-component-library';
import React, { ReactNode } from 'react';
import { useParams } from 'react-router';
import { getProjectDetails } from 'services/projects';
import { BygrProjectDetails } from 'types';
import { useAsyncState } from 'utils/hooks';
import ProjectDashboard from './ProjectDashboard';
// import ProjectInvitations from './ProjectInvitations';
import ProjectMembers from './ProjectMembers';
import ProjectModules from './ProjectModules';
import ProjectUnits from './ProjectUnits';
import ProjectLandingPage from './ProjectLandingPage';
import ProjectLinkedProject from './ProjectLinkedProject';
import theme from './Projects.module.scss';
import ProjectLicenses from './Licenses/ProjectLicenses';
import { ProjectFeatures } from './ProjectFeatures';

export type ProjectDetailsTab =
    | 'dashboard'
    | 'members'
    | 'units'
    | 'modules'
    | 'invitations'
    | 'licenses'
    | 'landing-page'
    | 'linked-project'
    | 'features';
interface ProjectDetailsProps {
    tab: ProjectDetailsTab;
}
interface TabSettings {
    id: ProjectDetailsTab;
    name: string;
    render(opts: { project: BygrProjectDetails; reload(): void }): ReactNode;
}

const tabs: TabSettings[] = [
    {
        id: 'dashboard',
        name: 'Dashboard',
        render: ({ project }) => <ProjectDashboard project={project} />,
    },
    {
        id: 'units',
        name: 'Units',
        render: ({ project }) => <ProjectUnits project={project} />,
    },
    {
        id: 'members',
        name: 'Members',
        render: ({ project }) => <ProjectMembers project={project} />,
    },
    {
        id: 'modules',
        name: 'Modules',
        render: ({ project, reload }) => <ProjectModules project={project} reloadProject={reload} />,
    },
    // {
    //     id: 'invitations',
    //     name: 'Invitations',
    //     render: ({ project, reload }) => <ProjectInvitations project={project} />,
    // },

    {
        id: 'licenses',
        name: 'Licenses',
        render: ({ project, reload }) => <ProjectLicenses project={project} />,
    },
    {
        id: 'landing-page',
        name: 'Landing page',
        render: ({ project, reload }) => <ProjectLandingPage project={project} />,
    },
    {
        id: 'linked-project',
        name: 'Linked project',
        render: ({ project, reload }) => <ProjectLinkedProject project={project} reloadProject={reload} />,
    },
    {
        id: 'features',
        name: 'Features',
        render: ({ project, reload }) => <ProjectFeatures project={project} reloadProject={reload} />,
    },
];

const ProjectDetails: React.FC<ProjectDetailsProps> = (props) => {
    const { projectId, tab } = useParams<{ projectId: string; tab: ProjectDetailsTab }>();
    const [project, , reload] = useAsyncState(() => getProjectDetails(+projectId), [projectId], null);

    if (!project) {
        return <LoadingIndicator />;
    }

    const renderProjectType = () => {
        if (project.isParentProject) {
            return <span className={theme.projectType}>(Parent)</span>;
        } else if (project.parentProjectId) {
            return <span className={theme.projectType}>(Sub)</span>;
        } else {
            return null;
        }
    };

    return (
        <div>
            <h3>
                Project {project.name}
                {renderProjectType()}
            </h3>
            <Tabs activeTabId={tab}>
                {tabs.map((tab) => (
                    <LinkTab key={tab.id} id={tab.id} name={tab.name} to={`/projects/${project.id}/${tab.id}`}>
                        <div>{tab.render({ project: project, reload: reload })}</div>
                    </LinkTab>
                ))}
            </Tabs>
        </div>
    );
};

export default ProjectDetails;
